// Time options for ride surge windows.
//
// Values are hours of the day on a 0-24 scale, in half hour steps, where 0.5
// means 00:30. The end time list also offers 24, meaning midnight of the next
// day. This differs from generateTimes.js, which represents that same moment as
// 0: the ride API compares startTime and endTime numerically, so a window such
// as 22:00-24:00 would never match if its end were stored as 0.

export function getWeekDays() {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
}

function formatTimeLabel(hours, minutesTime) {
    const minuteLabel = minutesTime === 0 ? '00' : minutesTime;

    if (hours === 0) {
        return '12.' + minuteLabel + 'AM';
    }

    if (hours === 12) {
        return '12.' + minuteLabel + 'PM';
    }

    if (hours > 12) {
        return (hours - 12) + '.' + minuteLabel + 'PM';
    }

    return hours + '.' + minuteLabel + 'AM';
}

export function generateSurgeTimes({ includeNextDayMidnight = false } = {}) {
    let times = [];

    for (let minutes = 0; minutes <= 1410; minutes = minutes + 30) {
        const hours = Math.floor(minutes / 60);
        const minutesTime = minutes % 60;

        times.push({
            value: hours + (minutesTime === 30 ? 0.5 : 0),
            label: formatTimeLabel(hours, minutesTime)
        });
    }

    if (includeNextDayMidnight) {
        times.push({ value: 24, label: '12.00AM*' });
    }

    return times;
}
